import React, { useState } from "react";
import "./GenericCard.css";

const Card = ({ title, children, onClick, background, dismissible, style = {}, titleStyle = {} }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }
  return (
    <div
      className="generic-card"
      style={{
        background: background || "#fff",
        cursor: onClick ? "pointer" : "default",
        position: "relative",
        ...style,
      }}
      onClick={onClick}
    >
      {title && (
        <div>
          <h3
            style={{
              marginTop: "0px",
              paddingBottom: "0px",
              marginBottom: "0px",
              ...titleStyle,
            }}
          >
            {title}{" "}
          </h3>
          <div
            style={{
              marginTop: "10px",
              marginLeft: "-20px",
              marginRight: "-20px",
              borderBottom: "1px solid var(--color-gray-selected)",
              marginBottom: "10px",
            }}
          ></div>
        </div>
      )}
      {dismissible && (
        <button className="generic-card-dismiss-button" onClick={() => setIsVisible(false)}>
          ✖
        </button>
      )}

      {children && <div className="generic-card-body">{children}</div>}
    </div>
  );
};

export default Card;
